<!-- PAGE HEADER -->
<div class="flex items-start justify-between">
  <div>
    <h2
      class="text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
    >
      Notification Logs
    </h2>
    <p class="mt-2 text-sm text-gray-500">
      Track delivery status and performance metrics
    </p>
  </div>

  <div class="flex items-center gap-3">

    <button
      type="button"
      mango-button
      routerLink=""
      class="w-fit items-center justify-end"
    >
      Export
    </button>
  </div>
</div>

<!-- STATS CARDS -->
<div class="mt-[0.94rem] grid gap-6 md:grid-cols-2 lg:grid-cols-4">
  <!-- STATS CARDS -->
  <!-- Total Sent -->
  <div class="rounded-lg border border-solid bg-mango-paleBlue p-6">
    <div class="flex items-center justify-between">
      <p class="text-sm font-semibold leading-5 text-mango-gray500">
        Total Sent
      </p>
      <span class="rounded-full bg-blue-200 p-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6 text-blue-600"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
          />
        </svg>
      </span>
    </div>
    <p class="mt-2 text-2xl font-semibold text-gray-900">{{ statsTotalCount | number }}</p>
    <p class="mt-1 text-sm text-gray-500">Across all broadcasts</p>
  </div>

  <!-- Delivered -->
  <div class="rounded-lg border border-solid bg-mango-paleGreen p-6">
    <div class="flex items-center justify-between">
      <p class="text-sm font-semibold leading-5 text-mango-gray500">
        Delivered
      </p>
      <span class="rounded-full bg-green-200 p-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6 text-green-600"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      </span>
    </div>
    <p class="mt-2 text-2xl font-semibold text-gray-900">{{ totalDelivered | number }}</p>
    <p class="mt-1 text-sm text-gray-500">{{ deliveryRate }} success rate</p>
  </div>

  <!-- Failed -->
  <div class="rounded-lg border bg-mango-shellRed p-6">
    <div class="flex items-center justify-between">
      <p class="text-sm font-semibold leading-5 text-mango-gray500">Failed</p>
      <span class="rounded-full bg-red-200 p-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          fill="none"
          class="size-6 text-red-600"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
          />
        </svg>
      </span>
    </div>
    <p class="mt-2 text-2xl font-semibold text-gray-900">{{ totalFailed | number }}</p>
    <p class="mt-1 text-sm text-gray-500">{{ failureRate }} failure rate</p>
  </div>

  <!-- Opened -->
  <!-- <div class="rounded-lg border bg-mango-lightOrange p-6">
    <div class="flex items-center justify-between">
      <p class="text-sm font-semibold leading-5 text-mango-gray500">Opened</p>
      <span class="rounded-full bg-orange-200 p-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          fill="none"
          class="size-6 text-orange-600"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          />
        </svg>
      </span>
    </div>
    <p class="mt-2 text-2xl font-semibold text-gray-900">8,945</p>
    <p class="mt-1 text-sm text-gray-500">75.2% open rate</p>
  </div> -->
</div>

<!-- Table Header -->
<div class="flex flex-1 gap-3">
  <!-- Search Input and Filters -->
  <app-filters [filters]="filterStructure"></app-filters>
  <app-table-refresh
    class="mt-5"
    [tableKey]="'notificationLogs'"
  ></app-table-refresh>
</div>

@if (isFetchingNotifications$ | async) {
<div class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div>
}

<!-- TABLE -->
<div
  *ngIf="(notificationList$ | async) as notificationListData"
  class="mt-[0.94rem] rounded-lg border border-solid bg-white"
>
  <!-- Table -->
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th
                scope="col"
                class="flex py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
              >
                S/N
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M7.99998 3.33301V12.6663M7.99998 12.6663L12.6666 7.99967M7.99998 12.6663L3.33331 7.99967"
                    stroke="#111849"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-semibold text-gray-500"
              >
                Notification
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-semibold text-gray-500"
              >
                Type
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-semibold text-gray-500"
              >
                Trigger
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-semibold text-gray-500"
              >
                Audience
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-semibold text-gray-500"
              >
                Sent At
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-semibold text-gray-500"
              >
                Delivered / Failed
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-semibold text-gray-500"
              >
                Status
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-right text-xs font-semibold text-gray-500"
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-100">
            <ng-container
              *ngIf="notificationListData?.data?.length; else noNotifications"
            >
              <tr
                *ngFor="let notification of notificationListData.data; let i = index"
                class="border-b border-gray-200 bg-white"
              >
                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p>{{ i + 1 }}</p>
                </td>
                <td class="border-b border-gray-200 bg-white px-6 py-5 text-sm">
                  <div class="flex items-center gap-3">
                    <div>
                      <p
                        class="whitespace-no-wrap text-sm font-medium text-gray-900"
                      >
                        {{ notification.title }}
                      </p>
                      <p class="text-xs text-gray-500">
                        {{ notification.message }}
                      </p>
                    </div>
                  </div>
                </td>

                <td class="border-b border-gray-200 bg-white px-6 py-5 text-sm">
                  <span
                    class="relative inline-block px-2 py-1 font-semibold leading-tight"
                  >
                    <span
                      aria-hidden
                      class="absolute inset-0 rounded-full opacity-50 {{
                    pushTypeLabel(notification.push_type) === 'Rich' ? 'bg-orange-200' :
                    pushTypeLabel(notification.push_type) === 'Interactive' ? 'bg-blue-200' : 'bg-purple-200'
                  }}"
                    ></span>
                    <span
                      class="relative text-xs {{
                    pushTypeLabel(notification.push_type) === 'Rich' ? 'text-orange-700' :
                    pushTypeLabel(notification.push_type) === 'Interactive' ? 'text-blue-700' : 'text-purple-700'
                  }}"
                    >
                      {{ pushTypeLabel(notification.push_type) | uppercase }}
                    </span>
                  </span>
                </td>

                <td class="border-b border-gray-200 bg-white px-6 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{ notification.trigger_type || '-' }}
                  </p>
                </td>

                <td class="border-b border-gray-200 bg-white px-6 py-5 text-sm">
                  @if (notification.audience.length) {
                    <div class="flex flex-wrap gap-1">
                      @for (a of notification.audience; track a) {
                        <span
                          class="inline-block rounded-full bg-mango-lightOrange px-2 py-0.5 text-[11px] font-medium text-mango"
                        >
                          {{ a }}
                        </span>
                      }
                    </div>
                  } @else {
                    <p>-</p>
                  }
                </td>

                <td class="border-b border-gray-200 bg-white px-6 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{ notification.sent_at ? (notification.sent_at | date: 'MMM d, y \'at\' h:mm a') : '-' }}
                  </p>
                </td>

                <td class="border-b border-gray-200 bg-white px-6 py-5 text-sm">
                  <div class="flex items-center gap-2 whitespace-nowrap">
                    <span
                      class="inline-flex items-center gap-1 rounded-full bg-mango-paleGreen px-2 py-0.5 text-xs font-medium text-mango-pineGreen"
                      title="Device sends succeeded"
                    >
                      &#10003; {{ (notification.success_count || 0) | number }}
                    </span>
                    <span
                      class="inline-flex items-center gap-1 rounded-full bg-mango-paleRed px-2 py-0.5 text-xs font-medium text-mango-red707"
                      title="Device sends failed"
                    >
                      &#10005; {{ (notification.failed_count || 0) | number }}
                    </span>
                  </div>
                </td>

                <td
                  class="sm:pmd:py-4 border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:text-sm md:px-4 lg:px-5"
                >
                  <span
                    class="relative inline-block px-2 py-1 font-semibold leading-tight"
                  >
                    <span
                      aria-hidden
                      class="absolute inset-0 rounded-full opacity-50 {{ statusBg(notification.status) }}"
                    ></span>
                    <span
                      class="relative text-xs {{ statusText(notification.status) }}"
                    >
                      {{ statusLabel(notification.status) }}
                    </span>
                  </span>
                </td>

                <td
                  class="relative whitespace-nowrap border-b py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                >
                  <div
                    class="relative inline-block w-fit cursor-pointer border-gray-200 bg-white text-left"
                  >
                    <app-dropdown
                      [id]="notification.id"
                      [actionList]="initDropdownList(notification)"
                    ></app-dropdown>
                  </div>
                </td>
              </tr>
            </ng-container>
            <ng-template #noNotifications>
              <tr>
                <td
                  colspan="9"
                  class="px-5 py-5 text-center text-sm text-gray-500"
                >
                  No notifications found!
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
        <app-table-navigator
          [total]="notificationListData?.total_count || 0"
          (onNavigation)="navigate($event)"
        >
        </app-table-navigator>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
